import React, { use, useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { add, remove, change, print, copy } from '../../assets/svg/footers'
import Select from '../../components/Select'
import { useState } from 'react'
import Modal from './modal'
import { useNavigate, useParams } from 'react-router-dom'
import Table from '../../components/Table'
import { useDispatch, useSelector } from 'react-redux'
import { statusesForStudents } from '../../assets/const'
import { createNotification } from '../../components/Notifications/Notifications'
import { getStrengthTableData } from '../../actions/settings/strength'
import { getGroupsForStudents, getStudents } from '../../actions/students/list'
import { deleteStudent } from '../../actions/students/other'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getSchoolYears } from '../../actions/common'
import moment from 'moment'
import { getCurrentYearUtils } from '../../utils/classBook'

const printData = [
  { id: 1, name: 'Личное дело' },
  { id: 2, name: 'Характеристика' },
  { id: 3, name: 'Аттестат' },
  { id: 4, name: 'Приложение' },
]
export default function Students() {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { list } = useSelector(state => state.students)
  const { groupsList, studentList } = list || {}
  const { tableData } = useSelector(state => state.settings.strength)
  const { studentId } = useParams()
  const { schoolYears } = useSelector(state => state.common)

  const [formData, setFormData] = useState({})
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [confirmation, setConfirmation] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  const handleDeleteStudent = () => {
    setConfirmation({ id: selectedStudent.mid, name: selectedStudent.fio || selectedStudent.calc_fio })
  }

  const acceptConfirmation = () => {
    dispatch(deleteStudent(confirmation.id))
    setConfirmation(false)
    setSelectedStudent(null)
  }

  const rejectConfirmation = () => {
    setConfirmation(false)
  }

  const openModal = (id) => () => {
    navigate(`/students/${id}`)
    setSelectedStudent(null)
  }

  const closeModal = () => navigate('/students')
  const goHome = () => navigate('/')

  useEffect(() => {
    dispatch(getStudents({ status: 'current' }))
    !tableData && dispatch(getStrengthTableData(0))
    dispatch(getGroupsForStudents())
    dispatch(getSchoolYears())
    setFormData({
      ...formData, status: 'current', school_year: getCurrentYearUtils(schoolYears, moment())
    })
  }, [])

  useEffect(() => {
    if (formData.parallel !== undefined) {
      const parallel = parseInt(formData.parallel) || 0
      dispatch(getGroupsForStudents(parallel ? { parallel } : undefined))
    }
  }, [formData.parallel])

  useEffect(() => {
    if (formData.status !== undefined) {
      setFormData({ status: formData.status })
    }
  }, [formData.status])

  const updateFilteres = () => {
    const status = formData.status || 'all'
    const school_year = parseInt(formData.school_year) || 0

    if ((status === 'expelled' || status === 'graduated') && !school_year) {
      createNotification('warning', 'Выберите учебный год для данного статуса', 'Обязательное поле', 4000)
      return
    }

    const string = {
      status,
      parallel: parseInt(formData.parallel) || 0,
      gid: parseInt(formData.gid) || 0,
      school_year,
    }
    dispatch(getStudents(string))
  }
  const handleInputChange = (e) => {
    const { name, value } = e.target
    if (name === 'parallel') {
      setFormData({ ...formData, parallel: parseInt(value) || 0, gid: 0 })
    } else {
      setFormData({ ...formData, [name]: value })
    }
  }
  const renderOption = (option, index) => {
    const { xp_key, value, trmid, cid, gid, work_status, id, pmid, did, name, title, year, access, } = option
    const optionValue = xp_key || value || trmid || cid || gid || work_status || id || pmid || did || year
    const optionTitle = name || title || value || year || work_status || access
    return <option key={`${optionValue}-${index}`} value={optionValue}>{optionTitle}</option>
  }

  const filteredStudentList = searchQuery
    ? studentList?.filter(s => {
      const fio = (s.fio || s.calc_fio || '').toLowerCase()
      return fio.includes(searchQuery.toLowerCase())
    })
    : studentList

  const renderRow = (row) => {
    const { fio, login, school_class, sex, birthday, mid, calc_fio, birthday_month_day, birth_year, parent_login, notebook_inventory_number, residing_index, residing_subject, transition_to, document_issue_date } = row

    return (
      <tr
        onClick={() => setSelectedStudent(row)}
        onDoubleClick={openModal(mid)}
        style={{ backgroundColor: mid === selectedStudent?.mid ? '#3689FF' : '' }}
      >
        <td>{fio || calc_fio}</td>
        <td>{mid}</td>
        <td>{school_class}</td>
        <td>{birthday}</td>
        <td>{birthday_month_day}</td>
        <td>{birth_year}</td>
        <td>{sex}</td>
        <td>{login}</td>
        <td>{parent_login}</td>
        <td>{notebook_inventory_number}</td>
        <td>{residing_index}</td>
        <td>{residing_subject}</td>
        <td>{transition_to}</td>
        <td>{document_issue_date}</td>
        <td>{ }</td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить "${confirmation.name}"?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <Modal
        studentId={studentId}
        isOpen={!!studentId}
        closeModal={closeModal}
        addMode={!parseInt(studentId)}
      />
      <h1>Личные дела учащихся</h1>
      <div className={styles.filter}>
        <input
          type="text"
          placeholder="Поиск..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          className={styles.searchInput}
        />
        {/* <div className={styles.filter1}> */}
        <Select
          title='Статус'
          name={"status"}
          options={statusesForStudents}
          value={formData?.status}
          onChange={handleInputChange}
        >
          <option value=''>Выбрать</option>
          {statusesForStudents?.map(renderOption)}

        </Select>
        {(formData?.status === 'expelled' || formData?.status === 'graduated') &&
          <Select
            title="Учебный год"
            name="school_year"
            options={[{ name: "Выбрать", xp_key: '0' }, ...schoolYears]}
            value={formData?.school_year || '0'}
            onChange={handleInputChange}
          />
        }
        {(formData?.status === 'current' || formData?.status === 'this_year') &&
          <>
            <Select
              title='Параллель'
              name={"parallel"}
              options={tableData && [{ name: "Все", value: '0' }, ...tableData]}
              value={formData?.parallel || '0'}
              onChange={handleInputChange}
            />
            <Select
              title="Класс"
              name={"gid"}
              options={groupsList && [{ name: "Все", gid: '0' }, ...groupsList]}
              value={formData?.gid || '0'}
              onChange={handleInputChange} />
          </>

        }

        {/* <span className={styles.title}>Воспитатель: Аврамкова Екатерина Валерьевна</span> */}
        <Button className={styles.filterButton} onClick={() => updateFilteres(formData)}>Обновить</Button>
        {/* </div> */}
      </div>
      <Table className={styles.tableStudent}>
        <thead>
          <tr>
            <th>Фамилия Имя Отчество</th>
            <th>ID(mid)</th>
            <th>Класс</th>
            <th>Дата рождения</th>
            <th>ДР(Месяц/день)</th>
            <th>Год</th>
            <th>Пол</th>
            <th>Логин</th>
            <th>Логин родителей</th>
            <th>Инв. №ноутбука</th>
            <th>Индекс</th>
            <th>Субъект РФ</th>
            <th>Собирается поступать в ВУЗ МО РФ</th>
            <th>Дата зачисления</th>
            <th>Получает рекомендации по питанию</th>
          </tr>
        </thead>
        <tbody>
          {filteredStudentList?.length === 0
            ? <tr><td colSpan={15} className={styles.emptyState}>Ничего не найдено</td></tr>
            : filteredStudentList?.map(renderRow)
          }
        </tbody>
      </Table>
      <p className={styles.info}>*используйте двойной клик для редактирования личного дела</p>
      <p className={styles.info}>Всего строк: {filteredStudentList?.length}</p>

      <footer className={styles.footer}>
        <Button className={styles.footerButton} onClick={openModal(0)} mode='bordered'>{add()}Добавить</Button>
        <Button className={styles.footerButton} mode='bordered' style={!!selectedStudent ? {} : { visibility: 'hidden' }} onClick={handleDeleteStudent}>{remove()}Удалить</Button>
        <Button className={styles.footerButton} style={{ padding: '.5rem 0' }}>{print()}Печать</Button>
        <Select
          name={"print"}
          // options={tableData}
          options={printData}
          value={formData?.print}
          onChange={handleInputChange}
          className={styles.printSelect}
        />
        <Button className={styles.footerButton} style={{ padding: '.5rem 0' }}>{copy()}Импорт из Excel</Button>
        <Button className={styles.footerButton} style={{ padding: '.5rem 0' }}>{copy()}В Excel</Button>
        <Button className={styles.footerButton} style={{ padding: '.5rem 0' }}>{copy()}Пароли / Экспорт в AD</Button>
        <Button mode='white' onClick={goHome}>Закрыть</Button>
      </footer>
    </div>
  )
}
